import { render, staticRenderFns } from "./CheckbokCustom.vue?vue&type=template&id=5338528e&scoped=true"
import script from "./CheckbokCustom.vue?vue&type=script&lang=ts"
export * from "./CheckbokCustom.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5338528e",
  null
  
)

export default component.exports